import React, { useState } from 'react';

const BluetoothConnectionView = () => {
  const [devices, setDevices] = useState([]);
  const [status, setStatus] = useState("");
  const [exploreResults, setExploreResults] = useState([]);

  // Main function to connect & open locker
  const openLocker = async () => {
    try {
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: [] // leave empty for now
      });

      const server = await device.gatt.connect();
      const services = await server.getPrimaryServices();

      for (const service of services) {
        console.log(`Service: ${service.uuid}`);
        const characteristics = await service.getCharacteristics();
        for (const char of characteristics) {
          console.log(`  Char: ${char.uuid}`, char.properties);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  // BLE Explorer for discovering services/characteristics
  const exploreBLE = async () => {
    setStatus("🛰️ Explorant serveis i característiques...");

    try {
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: ['generic_access']
      });

      const server = await device.gatt.connect();
      const services = await server.getPrimaryServices();

      const results = [];

      for (const service of services) {
        const characteristics = await service.getCharacteristics();

        results.push({
          uuid: service.uuid,
          characteristics: characteristics.map(c => ({
            uuid: c.uuid,
            properties: c.properties
          }))
        });
      }

      setExploreResults(results);
      setStatus("📡 Exploració completada");
    } catch (err) {
      console.error(err);
      setStatus("❌ Error durant l'exploració");
    }
  };

  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      padding: '2rem',
      background: '#f9fbfc',
      maxWidth: '900px',
      margin: '0 auto',
      borderRadius: '12px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}>
      <h2 style={{ color: '#333' }}>🔐 Connexió Bluetooth amb Taquilla</h2>

      <button onClick={openLocker} style={{
        padding: '12px 24px',
        fontSize: '16px',
        background: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        marginBottom: '20px'
      }}>
        Connectar i Obrir Taquilla
      </button>

      <p style={{ marginTop: '1rem', fontStyle: 'italic', color: '#555' }}>{status}</p>

      {devices.length > 0 && (
        <>
          <h4>📡 Dispositius detectats:</h4>
          <ul>
            {devices.map((d, idx) => (
              <li key={idx} style={{ color: '#222' }}>{d}</li>
            ))}
          </ul>
        </>
      )}

      <hr style={{ margin: '2rem 0', borderColor: '#ddd' }} />

      <h3 style={{ color: '#333' }}>🔎 Explorer BLE</h3>
      <button onClick={exploreBLE} style={{
        padding: '10px 20px',
        fontSize: '15px',
        background: '#28a745',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer'
      }}>
        Escanejar Serveis i Característiques
      </button>

      {exploreResults.length > 0 && (
        <div style={{ marginTop: '1.5rem' }}>
          {exploreResults.map((s, i) => (
            <div key={i} style={{ background: '#fff', padding: '1rem', marginBottom: '1rem', borderRadius: '8px' }}>
              <strong>🧩 Servei:</strong> {s.uuid}
              <ul style={{ marginTop: '0.5rem' }}>
                {s.characteristics.map((c, j) => (
                  <li key={j}>
                    🔹 <strong>UUID:</strong> {c.uuid}
                    <br />
                    🔸 <strong>Propietats:</strong> {Object.keys(c.properties).filter(k => c.properties[k]).join(', ')}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BluetoothConnectionView;
